import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const sectionWrapperOnMobiles = media.tablet`
  display: block;

  &>* {
    width: 100%;
    max-width: unset;
  }


  #left-bar-content {
    padding: 0;
  }

`;

export const WebinarSectionWrapper = styled.main`
  display: flex;
  min-height: 100vh;
  position: relative;

  ${sectionWrapperOnMobiles};
`;
